import script from "./EmergencyAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./EmergencyAlert.vue?vue&type=script&setup=true&lang=js"

import "./EmergencyAlert.vue?vue&type=style&index=0&id=2115e7b8&scoped=true&lang=css"

import exportComponent from "F:\\Grupo Low Cost\\Aplicación Mallorca\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2115e7b8"]])

export default __exports__